import {
    MultiBetLiveState,
    useMultiBetLiveData,
} from '@/modules/multibetRevamp/hook';
import { createContext } from 'react';

export const MultiBetLiveContext = createContext({} as MultiBetLiveState);
const { Provider } = MultiBetLiveContext;
type MultiBetLiveProviderProps = {
    children: JSX.Element;
};
export const MultiBetLiveProvider = (props: MultiBetLiveProviderProps) => {
    const { children } = props;
    const mb = useMultiBetLiveData();
    return <Provider value={mb}>{children}</Provider>;
};
